import { ref, onMounted, onUnmounted } from 'vue'
import { AXIOS_API } from '@/views/storege/index'
import axios_service from '@/utils/request'

export function useTimeTracker() {
    // 总使用时间（秒）
    const totalTime = ref(0)
    // 本次会话开始时间
    const sessionStartTime = ref(null)
    // 是否正在计时
    const isTracking = ref(false)
    // 定时器ID
    let timer = null
    
    const post_user_use_time_tracker = (use_seconds) => {
        // 将用户使用时间传给后端
        let params = new FormData()
        params.append('use_seconds', use_seconds)
        axios_service.request({method: 'post', url: `${AXIOS_API}/service-hours/track_usage_time`, data: params}).then((response) => {
            if(response.data.code!='200') return
            console.log('User Usage Time Tracking', use_seconds, response.data.message)
        })
    }

    // 开始计时
    const startTracking = () => {
        if (isTracking.value) return
        isTracking.value = true
        sessionStartTime.value = Date.now()
        
        // 每分钟更新一次时间
        timer = setInterval(() => {
        if (sessionStartTime.value) {
            // 如果用户没有登陆，则不计时
            let user_data = JSON.parse(sessionStorage.getItem('user_data'))
            if (!user_data?.role_id) return

            const currentTime = Date.now()
            totalTime.value = Math.floor((currentTime - sessionStartTime.value) / 1000)

            console.log('currentTime', totalTime.value)
            post_user_use_time_tracker(60)

        }
        }, 1000*60)
    }
    
    // 暂停计时
    const pauseTracking = () => {
        isTracking.value = false
        if (timer) {
            clearInterval(timer)
            timer = null
        }
    }
    
    // 重置计时器
    const resetTracking = () => {
        pauseTracking()
        totalTime.value = 0
        sessionStartTime.value = null
    }
    
    // 获取格式化时间
    const getFormattedTime = () => {
        const hours = Math.floor(totalTime.value / 3600)
        const minutes = Math.floor((totalTime.value % 3600) / 60)
        const seconds = totalTime.value % 60
        
        return {
            hours: hours.toString().padStart(2, '0'),
            minutes: minutes.toString().padStart(2, '0'),
            seconds: seconds.toString().padStart(2, '0'),
            totalSeconds: totalTime.value
        }
    }
    
    // 组件挂载时开始计时
    onMounted(() => {
        startTracking()
    })

    // 组件卸载时停止计时
    onUnmounted(() => {
        pauseTracking()
    })

    return {
        totalTime,
        isTracking,
        startTracking,
        pauseTracking,
        resetTracking,
        getFormattedTime
    }
}

// 在组件中使用示例：
// import { useTimeTracker } from './useTimeTracker'
// const { totalTime, getFormattedTime } = useTimeTracker()